<template>
  <TemplateHeader
    :header="'Emas Tersedia'"
    :withBackButton="true"
    :to="`/dashboard/cabang/${id}`"
    :branch_name="branch_name"
  >
    <TableEmas
      :tableLoading="tableLoading"
      :dataEmas="dataEmas"
      :headersEmas="headersEmas"
      :sortBy="dataEmas.id"
      :tableEdit="true"
    />
  </TemplateHeader>
</template>

<script>
import TemplateHeader from "../../../layouts/TemplateHeader.vue";
import TableEmas from "../../../components/Table/TableEmas.vue";

import { headersEmas } from "../../../data/headersEmas";

import dataService from "../../../services/data.service";

export default {
  components: {
    TemplateHeader,
    TableEmas,
  },
  data() {
    return {
      tableLoading: false,

      dataEmas: [],

      headersEmas: headersEmas,

      dataCabang: [],
      branch_name: "",
      id: this.$route.params.id,
    };
  },
  methods: {
    async getSubCabangDetail() {
      const id = this.$route.params.id;

      await dataService.getSubCabangDetail(id).then((res) => {
        const findCabang = res.data.data;

        this.branch_name = findCabang.sub_branch_name;
        this.cabangLoading = false;
      });
    },
    async getProductsGold() {
      this.tableLoading = true;
      const id = this.$route.params.id;

      await dataService.getProductsSubBranchGold(id).then((res) => {
        this.dataEmas = res.data.data.filter(
          (data) =>
            data.status === "Tersedia" ||
            data.status === "Belum Terpindai" ||
            data.status === "Pindah Cabang" ||
            data.status === "Perbaikan"
        );

        this.tableLoading = false;
      });
    },
  },
  created() {
    this.getProductsGold();
    this.getSubCabangDetail();
  },
};
</script>

<style scoped>
.myHeight {
  min-height: 100vh;
}
</style>
